<template>
  <div>
    <h5 class="checkpoint-header">
      <span
        v-if="checkpointRef && principle"
        class="label"
        :class="labelClass">{{ checkpointRef }}</span>
      <a
        :aria-expanded="expanded ? 'true' : 'false'"
        role="button"
        @click="expanded = !expanded"
        @keyup.enter="expanded = !expanded"
        tabindex="0">
        {{ expanded && '–' || '+' }} {{ title }}
        <span class="text-muted">({{ strategies.length }} strategies)</span>
      </a>
    </h5>

    <collapse v-model="expanded">
      <ul class="light-bullets">
        <li v-for="strategy of strategies" :key="strategy.uuid">
          <popover
            v-if="isPremium || strategy.demo"
            placement="right"
            :auto-placement="false"
            :title="strategy.title"
            trigger="hover-focus"
            :transition="50">
            <router-link :to="{name: 'StrategyDetailPage', params: {slugOrUuid: strategy.slug}}" target="_blank">{{ strategy.title }}</router-link>
            <div slot="popover">
              <p><img
                class="img-thumbnail"
                style="max-height: 120px"
                :src="strategy.image_url"></p>
              <p>{{ strategy.description.slice(0, 140) + '...' }}</p>
            </div>
          </popover>
          <p v-else class="locked-option text-muted">
            <span class="label label-danger lock-label"><i class="fa fa-lock"/></span>
            {{ strategy.title }}
          </p>
        </li>
      </ul>
    </collapse>
  </div>
</template>

<script>
import { expandEventMixin } from './mixins'
import { mapGetters } from 'vuex'

export default {
  name: 'CheckpointStrategyList',
  mixins: [expandEventMixin],
  props: {
    checkpointRef: {
      type: String,
      default: ''
    },
    principle: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      required: true
    },
    strategies: {
      type: Array,
      required: true
    }
  },
  computed: {
    ...mapGetters('user',['isPremium']),
    labelClass() {
      return (this.principle && `udl-${this.principle.split(' ')[0].toLowerCase()}`) || ''
    },
  }
}
</script>

<style scoped lang="less">
@import '~@/variables.less';

.checkpoint-header {
  font-size: 14px;
  font-weight: normal;
  line-height: 1.61em;
  margin-top: 0;

  a {
    color: #333;
  }
}
.label {
  text-decoration: none !important;
  font-size: var(--text-md);
  &.udl-representation {
    background: @udlRepresentationDark;
  }
  &.udl-action {
    background: @udlExpressionDark;
  }
  &.udl-engagement {
    background: @udlEngagementDark;
  }
}
.locked-option {
  margin-left: -24px;
  list-style: none;
  cursor: not-allowed;
}

</style>
